import CardTitle from "./CardTitle";

const Accountability = () => {
   return [
      <div>
         <CardTitle num={1} />
         <ul>
            <li>
               We own our decisions before, during and after they are made,
               regardless of the consequences - good and bad
            </li>
         </ul>
      </div>,

      <div>
         <CardTitle num={2} />
         <ul>
            <li>
               Agendas, always – a clear purpose and objective for the meeting
               upfront
            </li>
            <li>
               Actions, always, clearly documented with deadlines and owners
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={3} />
         <ul>
            <li>We only have rules that are necessary for:</li>
            <ul>
               <li>client</li>
               <li>learner</li>
               <li>people</li>
               <li>compliance</li>
               <li>governance purposes (e.g. regulatory reasons)</li>
            </ul>
         </ul>
      </div>,
      <div>
         <CardTitle num={4} />
         <ul>
            <li>
               Our commercial performance fuels our Purpose, and is supported by
               our Values
            </li>
            <li>
               Clear objectives, goal achievement, balanced with strong and
               robust process
            </li>
         </ul>
      </div>,

      <div>
         <CardTitle num={5} />
         <h3>We smile at: 😍</h3>
         <ul>
            <li>Taking ownership </li>
            <li>
               Collaborative decision making, but not at the expense of pace
            </li>
            <li>Collaborative execution, also not at the expense of pace</li>
         </ul>
         <br />
         <h3>We frown at: 😒</h3>
         <ul>
            <li>Blame</li>
            <li>Challenging for its own sake</li>
            <li>Slopy Shoulders</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={6} />
         <ul>
            <li>
               Outcomes, outcomes, outcomes, balanced with strong controlled
               inputs
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={7} />
         <ul>
            <li>
               Issues with group inputs or outputs are communicated to the whole
               group at the same time
            </li>
            <li>Specificity is essential in all forms of feedback</li>
            <li>
               Individual issues are communicated to only the individual in a
               timely manner
            </li>
            <li>Praise, where praise is due </li>
            <li>Specificity also applies with positives</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={8} />
         <ul>
            <li>
               Proudly share work in progress as much as, or more so than, we
               share completion
            </li>
            <li>Fail fast, learn, do-over - unashamedly</li>
         </ul>
      </div>,
   ];
};

export default Accountability;
